export default __webpack_public_path__ + "092b37504fcd0d973c46d5f1a600ab83.png";